import { render, staticRenderFns } from "./SyncInvoiceButton.vue?vue&type=template&id=40604522&scoped=true&"
import script from "./SyncInvoiceButton.vue?vue&type=script&lang=js&"
export * from "./SyncInvoiceButton.vue?vue&type=script&lang=js&"
import style0 from "./SyncInvoiceButton.vue?vue&type=style&index=0&id=40604522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40604522",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40604522')) {
      api.createRecord('40604522', component.options)
    } else {
      api.reload('40604522', component.options)
    }
    module.hot.accept("./SyncInvoiceButton.vue?vue&type=template&id=40604522&scoped=true&", function () {
      api.rerender('40604522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/CustomerInvoices/buttons/SyncInvoiceButton.vue"
export default component.exports